<template>
  <div class="notif-body">
    <div class="wording">
      <span class="notif-link" @click="goToUserInfo">{{ notif.payload.jsoncontent.user.firstName }} {{ notif.payload.jsoncontent.user.lastName }}</span>
      <span>&nbsp;{{ $t('notification.notifMentionInComment.mentionedInCommentOfPost') }}&nbsp;</span>
      <span class="notif-link" @click="goToPost">{{ truncateText(notif.payload.jsoncontent.postTitle, 'notification.notifMentionInComment.post') }}</span>
      <span> {{ $t('notification.notifMentionInComment.inCommunity') }} </span>
      <span class="notif-link" @click="goToCommunity">{{ truncateText(notif.payload.jsoncontent.CommunityName) }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotifMentionInComment',
  props: {
    notif: {
      type: Object,
      required: true
    }
  },
  methods: {
    goToUserInfo() {
      this.goToPage('userInfo', { id: this.notif.payload.jsoncontent.user.id })
    },
    goToCommunity() {
      this.goToPage('communityPage', { id: this.notif.payload.jsoncontent.idCommunity })
    },
    goToPost() {
      this.goToPage('postPage', { id: this.notif.payload.jsoncontent.postId })
    },
    goToPage(name, params) {
      this.$store.dispatch('showHidePanel', 'NOTIF')
      this.$store.dispatch('markNotificationIsRead', this.notif.id)
      this.$router.push({ name, params })
    },
    truncateText (str, defaultStr) {
      if (!str) {
        return this.$t(defaultStr)
      }
      if (str.length > 50) {
        return str.substring(0, 47) + '...'
      } else {
        return str
      }
    }
  }
}
</script>

<style lang="scss" scoped src="./NotifStyle.scss"></style>
